/**
 * Created by vadimdez on 20/01/2017.
 */
import { NgModule } from '@angular/core';
import { OrderByPipe } from './order-by.pipe';

@NgModule({
  declarations: [OrderByPipe],
  exports: [OrderByPipe],
  providers: [OrderByPipe]
})
export class OrderModule {}


// WEBPACK FOOTER //
// /app/src/app/pipes/orderPipe/pipe.module.ts